
import { IGetDataSourceMeasureHistoryByPointsParameters } from "./IGetDataSourceMeasureHistoryByPointsParameters";


export class GetDataSourceMeasureHistoryByPointsParameters implements IGetDataSourceMeasureHistoryByPointsParameters
{
    dataSourceId: number = 0;
    fromDate: Date = new Date();
    toDate: Date = new Date();
    maxPoints: number = 0;
}
